<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        المواد
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddMaterial @reloadTask="initialData()" :clinics="clinics" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.buyPrice`]="{ item }">
          <h4 style="padding: 0 3px">
            {{
              item.buyPrice.toLocaleString("en-US", {
                style: "currency",
                currency: "IQD",
              })
            }}
          </h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <DeleteMaterial @reloadTask="initialData" :dataToDelete="item" v-if="$store.state.userData.roleId == 1" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddMaterial from "./materials/AddMaterial.vue";
import DeleteMaterial from "./materials/DeleteMaterial.vue";
export default {
  components: {
    AddMaterial,
    DeleteMaterial,
  },
  data: () => ({
    overlay: false,
    search: "",
    materials: [],
    clinics: [],
    headers: [
      { text: "العدد", value: "index" },
      { text: "اسم المادة", value: "materialName" },
      { text: "سعر الشراء", value: "buyPrice" },
      { text: "اسم العيادة", value: "clinicName" },
      { text: "الاجراءات", value: "actions" },
    ],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/materials`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/clinics`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((materials, clinics) => {
            self.materials = materials.data;
            self.clinics = clinics.data;
            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.materials.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.materialName.toLowerCase().includes(v));
        });
      } else {
        return this.materials;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
